import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    Button,
    FunctionField,
    useListContext,
    DateInput,
    Filter
} from "react-admin";
import { useParams } from "react-router";
import BackButton from '../../Components/BackButton';
import { useEffect } from "react";

const ListActions = () => {
    const { setFilters, filterValues } = useListContext();  // 获取列表上下文
    const lastMonthRange = getLastMonthDateRange();
    const initialFilters = {
        startDate: lastMonthRange.startDate,
        endDate: lastMonthRange.endDate
    };  // 初始过滤器值

    // 重置过滤器函数
    const handleResetFilters = () => {
        setFilters(initialFilters);
    };

    return (
        <TopToolbar>
            <Button
                label="重置搜索"
                onClick={handleResetFilters}
                disabled={Object.keys(filterValues).length === 0}  // 当没有过滤条件时禁用
            />
        </TopToolbar>
    );
};

const getLastMonthDateRange = () => {
    const endDate = new Date();
    endDate.setDate(endDate.getDate() - 1); // 昨天
    
    const startDate = new Date(endDate);
    startDate.setMonth(startDate.getMonth() - 1); // 一个月前的昨天

    return {
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0]
    };
};


// 自定义过滤器组件，用于设置默认值
const CustomFilter = (props: any) => {
    const { setFilters, filterValues } = useListContext();

    useEffect(() => {
        const lastMonthRange = getLastMonthDateRange();

        // 设置默认过滤器值
        setFilters({
            startDate: lastMonthRange.startDate,
            endDate: lastMonthRange.endDate
        });
    }, []);

    return (
        <Filter>
            <DateInput
                label="开始时间"
                alwaysOn
                source="startDate"
            />
            <DateInput
                label="结束时间"
                alwaysOn
                source="endDate"
            />
        </Filter>
    );
};

export const trafficRevenueDetail = () => {
    const params = useParams(); // 获取URL参数
    const sn = params.id; // 提取设备ID

    // 构建返回设备详情页的路径
    const backPath = `/trafficRevenue/`;

    const lastMonthRange = getLastMonthDateRange();
    return (
        <>
            <TopToolbar sx={{ justifyContent: 'start' }}>
                <BackButton to={backPath} />
            </TopToolbar>
            <List title="流量销售权益详情"
                filter={{ sn: sn }}
                filters={<CustomFilter />}
                actions={< ListActions />}
                filterDefaultValues={{
                    startDate: lastMonthRange.startDate,
                    endDate: lastMonthRange.endDate,
                }}
                empty={false} resource="trafficRevenueDetail" >
                <Datagrid bulkActionButtons={false}>
                    {/* 修正字段映射 */}
                    <TextField source="id" label="序号" sortable={false} sx={{
                        whiteSpace: 'nowrap',
                    }} />
                    <FunctionField
                        label="实际收益"
                        source="totalIncome"
                        render={record => (record.totalIncome || 0) + '元'}
                        sortable={false}
                        sx={{
                            whiteSpace: 'nowrap',
                        }}
                    />
                    <FunctionField
                        label="累计流量"
                        source="totalTraffic"
                        render={record => {
                            // 确保值存在且为数字
                            const value = Number(record.totalTraffic);
                            if (isNaN(value)) return '0.000 TB';

                            // 将字节转换为TB并保留三位小数
                            const tb = (value / (1024 * 1024 * 1024 * 1024)).toFixed(3);
                            return `${tb} TB`;
                        }}
                        sortable={false}
                    />
                    <FunctionField
                        label="流量累计时长"
                        source="totalDuration"
                        render={record => {
                            const totalSeconds = record.totalDuration;
                            const days = Math.floor(totalSeconds / 86400);
                            const hours = Math.floor((totalSeconds % 86400) / 3600);

                            if (days > 0) {
                                return `${days}天${hours}小时`;
                            } else {
                                return `${hours}小时`;
                            }
                        }}
                        sortable={false}
                    />
                    <FunctionField
                        label="设备状态"
                        source="status"
                        render={record => record.status == 1 ? '在线' : '离线'}
                        sortable={false}
                    />
                </Datagrid>
            </List >
        </>
    );
};